export enum PaymentType {
  CARD = 'card',
  CASH = 'cash',
  BILL = 'bill',
  ROBOKASSA = 'robokassa',
  QR_CODE = 'qr_code',
}
